import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-100/50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
          <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950">页面未找到</h1>
        <p className="mt-4 text-sm text-foreground-500">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-line"></i>
          </div>
          返回首页
        </Link>
      </div>
    </div>
  );
}